import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs, File } from '@ztechapps/common.contract'
import type { IAction } from '@ztechapps/common.contract'
import type { SupportTicket } from '../entities/SupportTicket'

@InputType()
export class ReplyToSupportTicketArgs extends ActionArgs {
  @Field(() => ID)
  ticketId: string

  @Field(() => String)
  content: string

  @Field(() => [File], { nullable: true })
  attachments?: File[]
}

export interface IReplyToSupportTicket extends IAction<SupportTicket, ReplyToSupportTicketArgs> {}
